import React from 'react';
import { formatRoute } from 'react-router-named-routes';
// graphQL
import gql from 'graphql-tag';
// our components
import { PERMISSION } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import { Mutation } from 'components/common/Query';
import PermissionForm from 'components/Permission/Form';

/**
 * Mutation to create a permissions group
 */
export const CREATE_PERMISSIONS_GROUP_MUTATION = gql`
  mutation($name: String!, $permissions: [ID]!) {
    createPermissionGroup(input: { name: $name, permissions: $permissions }) {
      group {
        id
        name
      }
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class PermissionGroupCreateContainer extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  /**
   * @description
   * Callback called when mutation is completed.
   *
   * @param {Object} obj - Returned data.
   */
  permissionCreateCompleted = async ({ createPermissionGroup }) => {
    const { errors, group } = createPermissionGroup;
    const history = this.context;
    if (errors) {
      this.setState({ errors });
    } else {
      history.push(formatRoute(PERMISSION.DETAILS, { id: group.id }));
    }
  };

  /**
   * @description
   * Render PermissionGroupCreate component.
   */
  render() {
    const { errors } = this.state;
    return (
      <Mutation
        mutation={CREATE_PERMISSIONS_GROUP_MUTATION}
        onCompleted={this.permissionCreateCompleted}
      >
        {(handlePermissionCreate, { loading }) => (
          <PermissionForm
            permissionSave={data => {
              handlePermissionCreate({ variables: data });
            }}
            loading={loading}
            errors={errors}
          />
        )}
      </Mutation>
    );
  }
}

export default PermissionGroupCreateContainer;
